import {ChangeDetectionStrategy, Component, input} from "@angular/core";
import {ThreePLProviderType} from "../../../types/threePL-provider.type";
import {ThreePLServiceExtraData} from "../../models/threepl-service-details.model";

@Component({
  selector: "app-threepl-provider-extra-data-view",
  templateUrl: "./threepl-provider-extra-data-view.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreeplProviderExtraDataViewComponent {
  readonly providerType = input<string>();
  readonly extraData = input<ThreePLServiceExtraData>();

  readonly providers = ThreePLProviderType;
}
